'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = exports.FREE_CRM_SALES_STARTER_KIT = undefined;

var _enviro = require('self-service-api/core/utilities/enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProd = _enviro2.default.isProd();

var FREE_CRM_SALES_STARTER_KIT_PROD = 56;
var FREE_CRM_SALES_STARTER_KIT_QA = 119;

var FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD = 60;
var FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA = 122;

var FREE_CRM_SALES_STARTER_KIT = exports.FREE_CRM_SALES_STARTER_KIT = isProd ? FREE_CRM_SALES_STARTER_KIT_PROD : FREE_CRM_SALES_STARTER_KIT_QA;

var FREE_SERVICE_PROFESSIONAL_ONBOARDING = exports.FREE_SERVICE_PROFESSIONAL_ONBOARDING = isProd ? FREE_SERVICE_PROFESSIONAL_ONBOARDING_PROD : FREE_SERVICE_PROFESSIONAL_ONBOARDING_QA;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/ProductBasedOfferIds.js
// module id = 281
// module chunks = 3 4 5